import type { OfferFeatureCard } from "../types"
import { OfferSkillChip } from "./offer-skill-chip"

function FeatureCard({ card }: { card: OfferFeatureCard }) {
  return (
    <div className="flex flex-col overflow-hidden rounded-[32px] bg-dark-surface pb-6">
      {/* Natural aspect (cards vary in height); negative margin lets the text
          block overlap the image's lower edge */}
      <img src={card.image} alt="" className="-mb-12 block w-full" />
      <div className="relative flex flex-col gap-4 px-4">
        <div className="flex flex-col gap-2">
          <h3 className="font-display text-xl font-medium text-purple-light">{card.title}</h3>
          <p className="text-base leading-snug text-purple-light/70">{card.subtitle}</p>
        </div>
        <div className="flex flex-wrap gap-1">
          {card.chips.map((chip) => (
            <OfferSkillChip key={chip.label} chip={chip} />
          ))}
        </div>
      </div>
    </div>
  )
}

interface OfferFeatureCardsProps {
  heading: string
  cards: OfferFeatureCard[]
}

/** "Discover what…" heading + a stack of image feature cards with skill chips. */
export function OfferFeatureCards({ heading, cards }: OfferFeatureCardsProps) {
  return (
    <div data-slot="offer-feature-cards" className="flex flex-col gap-4">
      <h2 className="text-center font-display text-2xl font-medium text-purple-light">{heading}</h2>
      <div className="flex flex-col gap-4">
        {cards.map((card) => (
          <FeatureCard key={card.title} card={card} />
        ))}
      </div>
    </div>
  )
}
